import { ArrowUpRight, Heart, MapPin, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { compactNumber, place } from '@/lib/format';
import type { FounderSummary, ListingSummary } from '@/lib/types';
import { Avatar, Tags, Verified } from './Primitives';

export function FounderCard({ founder }: { founder: FounderSummary }) {
  return (
    <Link className="entity-card founder-card" to={`/founders/${founder.slug}`}>
      <div className="entity-top"><Avatar name={founder.name} src={founder.avatarUrl} size="lg" /><span className="card-arrow"><ArrowUpRight aria-hidden /></span></div>
      <div className="entity-title"><h3>{founder.name}</h3>{founder.verified && <Verified label="" />}</div>
      <p className="entity-subtitle">{founder.headline || 'Founder and community builder'}</p>
      <p className="entity-location"><MapPin aria-hidden />{place(founder.city, founder.country, founder.location)}</p>
      <Tags values={founder.tags} limit={3} />
      <div className="entity-stats"><span>{compactNumber(founder.listingCount)} ventures</span><span>{compactNumber(founder.followerCount)} followers</span></div>
    </Link>
  );
}

export function ListingCard({ listing }: { listing: ListingSummary }) {
  return (
    <Link className="entity-card listing-card" to={`/listings/${listing.slug}`}>
      <div className="entity-top"><Avatar name={listing.name} src={listing.logoUrl} size="lg" /><div className="card-badges">{listing.featured && <span className="featured">Featured</span>}<span className="card-arrow"><ArrowUpRight aria-hidden /></span></div></div>
      <div className="entity-title"><h3>{listing.name}</h3>{listing.verified && <Verified label="" />}</div>
      <p className="entity-subtitle">{listing.tagline || listing.description || 'Built by a member of the community'}</p>
      <Tags values={listing.tags} limit={3} />
      <div className="entity-stats"><span><Heart aria-hidden />{compactNumber(listing.supportCount)} supports</span><span><MessageCircle aria-hidden />{compactNumber(listing.reviewCount)} reviews</span></div>
    </Link>
  );
}
